export default "<p>locations works!</p>\n"